import MuiAppBar from '@mui/material/AppBar';
import { makeStyles } from '@mui/styles';
import classnames from 'classnames';
import React from 'react';

import { getIsMac } from '../utils/electron';

const useStyles = makeStyles(() => ({
  appBar: {
    WebkitAppRegion: 'no-drag',
  },
}));

interface Props {
  className?: string;
  style?: any;
  position?: 'fixed' | 'relative';
  children?: React.ReactNode;
}

const AppBar = ({ className, style, position, children }: Props) => {
  const classes = useStyles();
  let top = 0;
  if (window.isElectron) {
    const isMac = getIsMac();
    top = isMac ? 28 : 32;
  }
  return (
    <MuiAppBar className={classnames(classes.appBar, className)} position={position} style={{ ...style, top }}>
      {children}
    </MuiAppBar>
  );
};

export default AppBar;
